module.exports = __webpack_public_path__ + "static/img/logo-shby.bbc1ffcb.png";